import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

var models = [
    {name: "Analog Input", number: 0},
    {name: "Analog Output", number: 1},
    {name: "Analog Value", number: 2},
    {name: "Binary Input", number: 3},
    {name: "Binary Output", number: 4},
    {name: "Binary Value", number: 5},
    {name: "Calendar", number: 6},
    {name: "Command", number: 7},
    {name: "Device", number: 8},
    {name: "Event Enrollment", number: 9},
    {name: "File", number: 10},
    {name: "Group", number: 11},
    {name: "Loop", number: 12},
    {name: "Multi State Input", number: 13},
    {name: "Multi State Output", number: 14},
    {name: "Notification Class", number: 15},
    {name: "Program", number: 16},
    {name: "Schedule", number: 17},
    {name: "Averaging", number: 18},
    {name: "Multi State Value", number: 19},
    {name: "Trend Log", number: 20},
    {name: "Life Safety Point", number: 21},
    {name: "Life Safety Zone", number: 22},
    {name: "Accumulator", number: 23},
    {name: "Pulse Converter", number: 24},
    {name: "Event Log", number: 25},
    {name: "Global Group", number: 26},
    {name: "Trend Log Multiple", number: 27},
    {name: "Load Control", number: 28},
    {name: "Structured View", number: 29},
    {name: "Access Door", number: 30},
    {name: "Access Credential", number: 32},
    {name: "Access Point", number: 33},
    {name: "Access Rights", number: 34},
    {name: "Access User", number: 35},
    {name: "Access Zone", number: 36},
    {name: "Credential Data Input", number: 37},
    {name: "Network Security", number: 38},
    {name: "Bitstring Value", number: 39},
    {name: "Characterstring Value", number: 40},
    {name: "Date Pattern Value", number: 41},
    {name: "Date Value", number: 42},
    {name: "Datetime Pattern Value", number: 43},
    {name: "Datetime Value", number: 44},
    {name: "Integer Value", number: 45},
    {name: "Large Analog Value", number: 46},
    {name: "Octetstring Value", number: 47},
    {name: "Positive Integer Value", number: 48},
    {name: "Time Pattern Value", number: 49},
    {name: "Time Value", number: 50},
    {name: "Notification Forwarder", number: 51},
    {name: "Alert Enrollment", number: 52},
    {name: "Channel", number: 53}
];

export class BacnetObjectTypeCollection extends CachingCollection<Backbone.Model> {
    url = null;

    initialize() {
        this.add(models);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/BacnetObjectTypes.ts